import { render, staticRenderFns } from "./accountGroup.vue?vue&type=template&id=61e3737d&"
import script from "./accountGroup.vue?vue&type=script&lang=js&"
export * from "./accountGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports